<div class="card border-0 shadow-sm billing-settings-card">
  <!-- Header -->
  <div class="card-header bg-white">
    <h5 class="mb-1 fw-semibold">
      <i class="bi bi-credit-card-fill text-primary me-2"></i>
      Billing Settings
    </h5>

    <small class="text-muted">
      Maintain the details used for practice billing, statements, and account communications.
    </small>
  </div>

  <div class="card-body">
    @if (isLoading) {
      <div class="text-center py-4 text-muted">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        Loading billing settings...
      </div>
    }

    @if (!isLoading) {
      <div class="alert alert-info d-flex align-items-start billing-note">
        <i class="bi bi-info-circle-fill me-2 mt-1"></i>
        <div>
          Keep your billing contact information current so invoices and important account updates
          reach the right team.
        </div>
      </div>

      <!-- Billing Account Details -->
      <div class="card border-0 bg-light mb-4 billing-form-card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
            <div>
              <h6 class="fw-semibold mb-1">Billing Account Details</h6>
              <small class="text-muted"
                >Information used for invoices and account communication.</small
              >
            </div>

            <span class="badge text-bg-primary align-self-center">Account profile</span>
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Account Name</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="billing.accountName"
                placeholder="Practice billing account name"
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Billing Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="billing.billingEmail"
                placeholder="accounts@practice.co.za"
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Contact Number</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="billing.contactNumber"
                placeholder="+27 ..."
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">VAT Number</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="billing.vatNumber"
                placeholder="Optional"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Billing Summary -->
      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <h6 class="mb-1 fw-semibold">Billing Summary</h6>
          <small class="text-muted"
            >A quick view of the practice account schedule and balance.</small
          >
        </div>
      </div>

      <div class="row g-3">
        <div class="col-md-4">
          <div class="card billing-metric border-0 h-100">
            <div class="card-body">
              <div class="text-muted small mb-1">Next Billing Date</div>

              <div class="fs-5 fw-bold">
                {{ billing.nextBillingDate | date: 'dd MMM yyyy' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card billing-metric border-0 h-100">
            <div class="card-body">
              <div class="text-muted small mb-1">Amount Owed</div>

              <div
                class="fs-5 fw-bold"
                [class.text-success]="billing.amountOwed === 0"
                [class.text-danger]="billing.amountOwed > 0"
              >
                R{{ billing.amountOwed | number: '1.2-2' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card billing-metric border-0 h-100">
            <div class="card-body">
              <div class="text-muted small mb-1">Invoice Cycle</div>

              <div class="fs-5 fw-bold">Week {{ billing.invoiceGenerationWeek }}</div>
            </div>
          </div>
        </div>
      </div>

      @if (billing.amountOwed > 0) {
        <div class="alert alert-warning mt-4 mb-0">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>

          Your account has an outstanding balance of
          <strong> R{{ billing.amountOwed | number: '1.2-2' }} </strong>
        </div>
      }
    }
  </div>

  @if (!isLoading) {
    <div
      class="card-footer bg-white d-flex justify-content-between align-items-center flex-wrap gap-2"
    >
      <small class="text-muted">
        Saved details will be used for future practice billing communications.
      </small>

      <button
        class="btn btn-primary"
        [disabled]="isSaving || isLoading"
        (click)="saveBillingDetails()"
      >
        <i class="bi bi-floppy-fill me-2"></i>
        {{ isSaving ? 'Saving...' : 'Save Billing Details' }}
      </button>
    </div>
  }
</div>
